import React from "react";
import { useSelector } from "react-redux";
import { selectText } from "../../../translation/translationSlice";
import "./Label.scss";

const Label = React.memo((props) => {
  const t = useSelector(selectText);
  return (
    <div className="Label">
      <div className="Label_label">{t(props.label)}</div>
    </div>
  );
});

export default Label;
